const state = () => {
  return {
    sc_shifts: [],
    sc_shift: {},
    sc_shift_filters: {},
  }
}

export default state;
